<template>
  <div class="my-pages-template">
    <div v-if="showGoBack" class="my-pages-template__action">
      <oie-base-action theme="flat" @click="goBack">
        <template #iconPrepend>
          <oie-base-icon icon="arrow-left" size="s"></oie-base-icon>
        </template>
        {{ tStatic('goBack') }}
      </oie-base-action>
    </div>
    <oie-my-pages-title
      v-if="title || text"
      class="my-pages-template__title"
      :title="title"
      :text="text"></oie-my-pages-title>
    <div class="my-pages-template__content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import myPages from '@/mixins/my-pages'

export default {
  mixins: [myPages],
  props: {
    title: {
      type: String,
      default: ''
    },
    text: {
      type: String,
      required: false,
      default: ''
    },
    withGoBack: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    showGoBack() {
      return this.withGoBack && this.navigationHistory.length >= 2
    }
  }

}
</script>

<style lang="scss">
.my-pages-template {
  position: relative;
  background-color: color(white);
  padding: measure(half);

  @include media(medium) {
    padding: measure(full);
  }
}

.my-pages-template__action {
  position: absolute;
  top: -38px;
  left: 0;
}

.my-pages-template__title{
  margin-bottom: measure(full);
}

.my-pages-template__content>:not(:last-child) {
  margin-bottom: measure(half);

  @include media(large) {
    margin-bottom: measure(full);
  }
}
</style>
